module.exports = __webpack_public_path__ + "img/40_38_049_070.5fd67ebc.jpg";